import script from "./countdown-banner.vue?vue&type=script&setup=true&lang=js"
export * from "./countdown-banner.vue?vue&type=script&setup=true&lang=js"

import "./countdown-banner.vue?vue&type=style&index=0&id=301eec6a&lang=less"

const __exports__ = script;

export default __exports__